import { configureStore } from '@reduxjs/toolkit'
import menuReducer from "./global/menuSlice"
export const store = configureStore({
    reducer: {
        menu: menuReducer
    },
})